import { render } from "./InputInfo.vue?vue&type=template&id=473fdb66&scoped=true"
import script from "./InputInfo.vue?vue&type=script&lang=js"
export * from "./InputInfo.vue?vue&type=script&lang=js"

import "./InputInfo.vue?vue&type=style&index=0&id=473fdb66&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-473fdb66"]])

export default __exports__